import { useEffect, useRef, useState } from "react";
import { Volume2, Loader2, X } from "lucide-react";
import { api, todayStr } from "../lib/api";

export const MorningGreeting = () => {
  const [greeting, setGreeting] = useState("");
  const [visible, setVisible] = useState(false);
  const [loadingAudio, setLoadingAudio] = useState(false);
  const [playing, setPlaying] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    if (localStorage.getItem("ss_greeting_date") === todayStr()) return;
    let cancelled = false;
    api.get("/greeting").then((r) => {
      if (cancelled) return;
      setGreeting(r.data.text);
      setVisible(true);
      localStorage.setItem("ss_greeting_date", todayStr());
    }).catch(() => {});
    return () => { cancelled = true; };
  }, []);

  const speak = async () => {
    if (audioRef.current) {
      audioRef.current.play();
      setPlaying(true);
      return;
    }
    setLoadingAudio(true);
    try {
      const { data } = await api.post("/tts", { text: greeting });
      const audio = new Audio(`data:audio/mp3;base64,${data.audio_base64}`);
      audioRef.current = audio;
      audio.onended = () => setPlaying(false);
      await audio.play();
      setPlaying(true);
    } catch {
      setPlaying(false);
    }
    setLoadingAudio(false);
  };

  if (!visible || !greeting) return null;

  return (
    <div className="relative bg-white border-2 border-black rounded-2xl rounded-tl-none shadow-[4px_4px_0px_rgba(0,0,0,1)] p-4 pr-10 animate-in fade-in slide-in-from-top-2 duration-500" data-testid="morning-greeting-bubble">
      <button onClick={() => setVisible(false)} data-testid="greeting-dismiss-button"
        className="absolute top-2 right-2 p-1 text-gray-400 hover:text-black transition-colors">
        <X size={14} />
      </button>
      <p className="text-sm font-medium leading-relaxed">{greeting}</p>
      <button onClick={speak} disabled={loadingAudio || playing} data-testid="greeting-play-button"
        className="mt-2 inline-flex items-center gap-1.5 text-xs font-bold bg-[#F2C6DE] border-2 border-black rounded-full px-3 py-1.5 shadow-[2px_2px_0px_rgba(0,0,0,1)] active:shadow-none active:translate-y-[2px] transition-all disabled:opacity-60">
        {loadingAudio ? <Loader2 size={13} className="animate-spin" /> : <Volume2 size={13} />}
        {playing ? "Mia's speaking..." : "Hear Mia say it"}
      </button>
    </div>
  );
};
